import { render, staticRenderFns } from "./mainWindow.vue?vue&type=template&id=0d0377e5&scoped=true"
import script from "./mainWindow.vue?vue&type=script&lang=js"
export * from "./mainWindow.vue?vue&type=script&lang=js"
import style0 from "./mainWindow.vue?vue&type=style&index=0&id=0d0377e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0377e5",
  null
  
)

export default component.exports